import { ConfidentialityTypeEnum } from "../enums/ConfidentialityTypeEnum";
import { PatientRecordItem } from "./PatientRecordItem";

export interface SubContactItemType {
  id: number;
  confidentialityType: ConfidentialityTypeEnum;
  freeTextContent: string;
  hasCareElement: boolean;
  hasDocument: boolean;
  listPatientRecordItem: Array<PatientRecordItem>;
  contactID: number;
  dto?: object;
}

export class SubContactItem implements SubContactItemType {
  id: number;
  confidentialityType: ConfidentialityTypeEnum;
  freeTextContent: string;
  hasCareElement: boolean;
  hasDocument: boolean;
  listPatientRecordItem: Array<PatientRecordItem>;
  contactID: number;

  constructor(data?: SubContactItemType) {
    this.id = -1;
    this.confidentialityType = ConfidentialityTypeEnum.NA;
    this.freeTextContent = "";
    this.hasCareElement = false;
    this.hasDocument = false;
    this.listPatientRecordItem = [];
    this.contactID = -1;
    data && Object.assign(this, data);
  }
}
